export default defineNuxtRouteMiddleware((to) => {
  let duplicateProp = false;
  const query = { ...to.query };
  const cleanedQuery: Record<string, string> = {};

  for (const property in query) {
    const value = query[property];
    if (Array.isArray(value)) {
      cleanedQuery[property] = String(value[0]);
      duplicateProp = true;
    } else {
      cleanedQuery[property] = String(value);
    }
  }

  if (duplicateProp) {
    // Reconstruct the fullPath from the path and cleaned query
    const searchParams = new URLSearchParams(cleanedQuery).toString();
    const newFullPath = searchParams ? `${to.path}?${searchParams}` : to.path;
    return navigateTo(newFullPath, { replace: true });
  }
});
